import { Box, Button, Grid, Typography, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PeopleNoteImg from '../../images/People+Notes.png';
import IconIntegrationsImg from '../../images/Integrations+Icons.png';
import PeoplePageImg from '../../images/PeoplePage.png';
import UploadSearchImg from '../../images/Upload+Search.png';
import { MoteIcon } from 'constants/mote';

const LandingPage = () => {
    const navigate = useNavigate();

    return (
        <Box>
            {/* FIRST SECTION */}
            <Grid container spacing={2} sx={{ marginTop:"5%", paddingLeft:"8%", marginBottom:"9%" }}>
                <Grid item xs={6} direction="column">
                    <Box paddingTop="100px" paddingRight="150px">
                        <Typography variant="h1">Aggregate your</Typography>
                        <Typography variant="h1" color="primary.main" sx={{ marginBottom:"24px" }}>interactions across platforms</Typography>
                        <Typography variant="h3" color="primary.main" sx={{ marginBottom:"24px" }}>möte allows you to search conversations, files, and meeting notes across your various platforms and accounts</Typography>

                        <Button 
                            variant="contained" 
                            sx={{textTransform: "none", borderRadius:"20rem"}}
                            onClick={() => navigate('/login', { state: { initialPageType: "register" } })}
                        >
                            Get Started
                        </Button>
                    </Box>
                </Grid>
                <Grid item xs={6} direction="column">
                    <img
                        src={PeopleNoteImg}
                        id={PeopleNoteImg}
                        alt="People and Notes Image"
                        style={{ maxWidth: "100%", height: "auto" }}
                    />
                </Grid>
            </Grid>

            {/* SECOND SECTION */}
            <Grid container spacing={1} sx={{ bgcolor: 'primary.main' }}>
                <Grid item xs={12}>
                    <Typography
                    variant="h2"
                    color="white"
                    sx={{ fontWeight: 'medium', marginTop: '3%', marginBottom: '2%' }}
                    align="center"
                    >
                        Search All Your Conversations and Files from One Location
                    </Typography>

                    <Box maxWidth="50%" mx="auto">
                        <Typography
                            variant="h4"
                            color="white"
                            align="center"
                            sx={{ fontStyle: 'italic', marginBottom: '10%' }}
                        >
                            Review and summarize every email, chat message, file shared, and meeting
                            you have had across your different platforms
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: "6%" }}>
                        <img
                            src={IconIntegrationsImg}
                            id={IconIntegrationsImg}
                            alt="Integrations Image"
                            style={{ maxWidth: "25%", height: "auto" }}
                        />
                    </Box>
                </Grid>
            </Grid>

            {/* THIRD SECTION */}
            <Grid container spacing={2} sx={{ marginTop:"5%", paddingLeft:"8%", marginBottom:"13%" }}>
                <Grid item xs={6} direction="column">
                    <Box paddingTop="100px" paddingRight="150px">
                        <Typography variant="h1">Search Your Conversations</Typography>
                        <Typography variant="h1" color="primary.main" sx={{ marginBottom:"24px" }}>people / groups</Typography>
                        <Typography variant="h3" color="primary.main" sx={{ marginBottom:"24px" }}>möte allows you to search across email and message apps to review every conversation, file shared, and action item</Typography>

                    </Box>
                </Grid>
                <Grid item xs={6} direction="column">
                    <img
                        src={PeoplePageImg}
                        id={PeoplePageImg}
                        alt="People Page Image"
                        style={{ maxWidth: "100%", height: "auto" }}
                    />
                </Grid>
            </Grid>

            {/* FOURTH SECTION */}
            <Grid container spacing={2} sx={{ paddingTop:"8%", bgcolor: 'primary.main', paddingLeft:"8%", paddingBottom:"9%" }}>
                <Grid item xs={6} direction="column">
                    <Box paddingTop="100px" paddingRight="150px">
                        <Typography variant="h1" color="white">Search Your Files</Typography>
                        <Typography variant="h1" color="primary.container" sx={{ marginBottom:"24px" }}>files / notes</Typography>
                        <Typography variant="h3" color="primary.container" sx={{ marginBottom:"24px" }}>möte allows you to upload and search across your file storage apps and chat history to find your files quickly and efficiently</Typography>

                    </Box>
                </Grid>
                <Grid item xs={6} direction="column">
                    <img
                        src={UploadSearchImg}
                        id={UploadSearchImg}
                        alt="Upload + Search Page Image"
                        style={{ maxWidth: "100%", height: "auto" }}
                    />
                </Grid>
            </Grid>

            {/* FIFTH SECTION */}
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Box sx={{ background: "linear-gradient(98.19deg, #3B57B8 -7.46%, #DCE1FF 99.11%)", borderRadius:"15px", boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", margin:"155px", display:"flex", flexDirection: "column", alignItems:"center", justifyContent: "center" }}>
                        {/* MOTE LOGO */}
                        <Box sx={{ margin:"30px" }}>
                            <IconButton disableRipple onClick={() => navigate("/")}>
                                <MoteIcon sx={{ fontSize: 100 }}/>
                            </IconButton>
                        </Box>
                        <Typography variant="h1" color="white" sx={{ margin:"15px" }}>Start Searching Today!</Typography>
                        <Typography variant="h3" color="white" sx={{ margin:"15px" }}>Integrate your conversations and files into one workspace</Typography>
                        <Button 
                            variant="contained" 
                            sx={{textTransform: "none", borderRadius:"20rem", marginBottom:"30px"}}
                            onClick={() => navigate('/login', { state: { initialPageType: "register" } })}
                            size='large'
                        >
                            Try for Free
                        </Button>
                    </Box>
                </Grid>
            </Grid>
            

        </Box>
    )
};

export default LandingPage;



// import React, { useState } from 'react';

// import {
//     Box,
//     Typography,
//     IconButton,
//     Grid,
//     Dialog,
//     DialogContent,
// } from '@mui/material';

// import { ExpandMoreRounded, ExpandLessRounded, VerticalAlignTopRounded } from '@mui/icons-material';
// import { MoteColoredIcon, MoteIcon } from 'constants/mote';
// import HomePageImg from '../../images/mote-homepage.png';
// import CalendarPageImg from '../../images/mote-calendarpage.png';
// import UploadPageImg from '../../images/mote-uploadpage.png';
// import SearchPageImg from '../../images/mote-searchpage.png';

// const LandingPage = () => {
//     const moteColor = "#3b57b8";
//     const moteSecondary = "#ffffff";
//     const topLevel = "top-level";
//     const introLevel = "intro-level";
//     const secondLevel = "second-level";
//     const thirdLevel = "third-level";
//     const fourthLevel = "fourth-level";
//     const fifthLevel = "fifth-level";

//     const [isExpanded, setIsExpanded] = useState(false);
//     const [currentImage, setCurrentImage] = useState(null);

//     const expandImage = (event) => {
//         setIsExpanded(true);
//         setCurrentImage(event.target.id);
//     };

//     const handleCloseImage = () => {
//         setIsExpanded(false);
//         setCurrentImage(null);
//     }

//     const scrollTo = (level) => {
//         const box = document.getElementById(level);
//         box.scrollIntoView({ behavior: "smooth" });
//     };

//     const scrollToIntro = () => {
//         scrollTo(introLevel);
//     };

//     const scrollToTop = () => {
//         scrollTo(topLevel);
//     };

//     const scrollToSecond = () => {
//         scrollTo(secondLevel);
//     };

//     const scrollToThird = () => {
//         scrollTo(thirdLevel);
//     };

//     const scrollToFourth = () => {
//         scrollTo(fourthLevel);
//     };

//     const scrollToFifth = () => {
//         scrollTo(fifthLevel);
//     };

//     const ImageDialog = () => {
//         return (
//             <Dialog open={isExpanded} onClose={handleCloseImage} style={{ width: "100%", height: "100%" }}>
//                 <DialogContent>
//                     <img 
//                         src={currentImage}
//                     />
//                 </DialogContent>
//             </Dialog>
//         );
//     };

//     return (
//         <Box container>
//             <Box id={topLevel} height="100vh" display="flex" justifyContent="center" alignItems="center" flexDirection="column">
//                 <Typography color={moteColor} variant="h1" fontWeight="700">Welcome to</Typography>
//                 <Box display="flex" justifyContent="center" alignItems="center" marginBottom={5}>
//                     <MoteColoredIcon sx={{ fontSize: 100 }} />
//                 </Box>
//                 <Box display="flex" justifyContent="center" alignItems="center" marginTop={5}>
//                     <IconButton onClick={scrollToIntro}>
//                         <ExpandMoreRounded sx={{ color: moteColor, fontSize: 50 }}/>
//                     </IconButton>
//                 </Box>
//             </Box>

//             <Box id={introLevel} bgcolor={moteColor} width="100%" height="100vh" display="flex" justifyContent="center" alignItems="center" flexDirection="column">
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: "center", width: "100%" }}>
//                     <Grid container spacing={2}>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', flexDirection: 'column', ml: '10rem' }}>
//                                 <Typography variant="h2" fontWeight="700" mb="2rem" color={moteSecondary}>Your Central Hub for Organization.</Typography>
//                                 <IconButton onClick={expandImage}>
//                                     <img
//                                         src={HomePageImg}
//                                         id={HomePageImg}
//                                         alt="Home Page Image"
//                                         style={{ maxWidth: "100%", height: "auto", border: `4px solid ${moteSecondary}`, borderRadius: "10px" }}
//                                     />
//                                 </IconButton>
//                                 <Typography variant="h2" fontWeight="700" mt="2rem" color={moteSecondary}>All in One, Simple Location.</Typography>
//                                 <ImageDialog />
//                             </Box>
//                         </Grid>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column' }}>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginBottom={5}>
//                                     <IconButton onClick={scrollToTop}>
//                                         <ExpandLessRounded sx={{ color: moteSecondary, fontSize: 50 }} />
//                                     </IconButton>
//                                 </Box>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginTop={5} marginBottom={5}>
//                                     <MoteIcon sx={{ fontSize: 100 }} />
//                                 </Box>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginTop={5}>
//                                     <IconButton onClick={scrollToSecond}>
//                                         <ExpandMoreRounded sx={{ color: moteSecondary, fontSize: 50 }} />
//                                     </IconButton>
//                                 </Box>
//                             </Box>
//                         </Grid>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', flexDirection: 'column', mr: '10rem' }}>
//                                 <Typography variant="h2" fontWeight="700" mb="2rem" mr="10rem" color={moteSecondary}>So, What's in Your Home Page?</Typography>
//                                 <Box sx={{ border: `4px solid ${moteSecondary}`, backgroundColor: moteColor, width: '100%', height: '100%', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', mr: '10rem' }}>
//                                     <Typography display="flex" variant="h4" fontWeight="600" color={moteSecondary} 
//                                                 sx={{ wordWrap: 'break-word', wordBreak: 'break-word', textAlign: "center", justifyContent: "center", alignItems: "center", ml: "1rem", mr: "1rem", mt: "1rem", mb: "1rem", height: "100%", lineHeight: "1.75" }}
//                                         >
//                                         Our home page is the hub of all your work-related activities. With just a glance, 
//                                         you can stay up to date with all the important information you need. View upcoming 
//                                         meetings and ensure that you never miss a deadline. Check on recent interactions to 
//                                         stay on top of your projects and stay in sync with your team. Keep track of your 
//                                         to-do list with action items for your current workflows, so you never forget what 
//                                         needs to be done. And don't forget the files you've made accessible from our platform – 
//                                         with our home page, they're just a click away. With all this functionality in one place, 
//                                         you can be sure that our home page will help you stay organized and efficient, 
//                                         making your work life a breeze.
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                 </Box>
//             </Box>

//             <Box id={secondLevel} bgcolor={moteSecondary} width="100%" height="100vh" display="flex" justifyContent="center" alignItems="center" flexDirection="column">
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: "center", width: "100%" }}>
//                     <Grid container spacing={2}>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', flexDirection: 'column', ml: '10rem' }}>
//                                 <Typography variant="h2" fontWeight="700" mb="2rem" ml="10rem" color={moteColor}>Scheduling, Made Simple.</Typography>
//                                 <Box sx={{ border: `4px solid ${moteColor}`, backgroundColor: moteSecondary, width: '100%', height: '100%', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', ml: '10rem' }}>
//                                     <Typography display="flex" variant="h4" fontWeight="600" color={moteColor} 
//                                                 sx={{ wordWrap: 'break-word', wordBreak: 'break-word', textAlign: "center", justifyContent: "center", alignItems: "center", ml: "1rem", mr: "1rem", mt: "1rem", mb: "1rem", height: "100%", lineHeight: "1.75" }}
//                                         >
//                                         With our calendar page, you can finally have all your meetings, appointments, and events 
//                                         organized in one convenient location. By seamlessly integrating your Google and Microsoft 
//                                         calendars, you'll never have to worry about missing an important event again. Our platform 
//                                         allows you to easily connect all your accounts and calendars together, ensuring that you 
//                                         have all the information you need at your fingertips. Our calendar page is perfect for busy 
//                                         professionals who want to streamline their day-to-day activities and keep everything organized.
//                                         With our user-friendly interface and intuitive design, you'll wonder how you ever managed without it.
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                         </Grid>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column' }}>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginBottom={5}>
//                                     <IconButton onClick={scrollToIntro}>
//                                         <ExpandLessRounded sx={{ color: moteColor, fontSize: 50 }} />
//                                     </IconButton>
//                                 </Box>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginTop={5} marginBottom={5}>
//                                     <MoteColoredIcon sx={{ fontSize: 100 }} />
//                                 </Box>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginTop={5}>
//                                     <IconButton onClick={scrollToThird}>
//                                         <ExpandMoreRounded sx={{ color: moteColor, fontSize: 50 }} />
//                                     </IconButton>
//                                 </Box>
//                             </Box>
//                         </Grid>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', flexDirection: 'column', mr: '10rem' }}>
//                                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', flexDirection: 'column', mr: '10rem' }}>
//                                     <Typography variant="h2" fontWeight="700" mb="2rem" color={moteColor}>Schedule and See What's Most Important.</Typography>
//                                     <IconButton onClick={expandImage}>
//                                         <img
//                                             src={CalendarPageImg}
//                                             id={CalendarPageImg}
//                                             alt="Calendar Page Image"
//                                             style={{ maxWidth: "100%", height: "auto", border: `4px solid ${moteColor}`, borderRadius: "10px" }}
//                                         />
//                                     </IconButton>
//                                     <Typography variant="h2" fontWeight="700" mt="2rem" color={moteColor}>All Your Accounts, All in One Place.</Typography>
//                                     <ImageDialog />
//                                 </Box>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                 </Box>
//             </Box>

//             <Box id={thirdLevel} bgcolor={moteColor} width="100%" height="100vh" display="flex" justifyContent="center" alignItems="center" flexDirection="column">
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: "center", width: "100%" }}>
//                     <Grid container spacing={2}>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', flexDirection: 'column', ml: '10rem' }}>
//                                 <Typography variant="h2" fontWeight="700" mb="2rem" color={moteSecondary}>Tracking Interactions Made Easy.</Typography>
//                                 <IconButton onClick={expandImage}>
//                                     <img
//                                         src={HomePageImg}
//                                         id={HomePageImg}
//                                         alt="Home Page Image"
//                                         style={{ maxWidth: "100%", height: "auto", border: `4px solid ${moteSecondary}`, borderRadius: "10px" }}
//                                     />
//                                 </IconButton>
//                                 <Typography variant="h2" fontWeight="700" mt="2rem" color={moteSecondary}>Let Us Remember Who You Work With, for You.</Typography>
//                                 <ImageDialog />
//                             </Box>
//                         </Grid>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column' }}>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginBottom={5}>
//                                     <IconButton onClick={scrollToSecond}>
//                                         <ExpandLessRounded sx={{ color: moteSecondary, fontSize: 50 }} />
//                                     </IconButton>
//                                 </Box>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginTop={5} marginBottom={5}>
//                                     <MoteIcon sx={{ fontSize: 100 }} />
//                                 </Box>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginTop={5}>
//                                     <IconButton onClick={scrollToFourth}>
//                                         <ExpandMoreRounded sx={{ color: moteSecondary, fontSize: 50 }} />
//                                     </IconButton>
//                                 </Box>
//                             </Box>
//                         </Grid>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', flexDirection: 'column', mr: '10rem' }}>
//                                 <Typography variant="h2" fontWeight="700" mb="2rem" mr="10rem" color={moteSecondary} sx={{ textAlign: "center" }}>Never Miss a Beat on Who You're Speaking to.</Typography>
//                                 <Box sx={{ border: `4px solid ${moteSecondary}`, backgroundColor: moteColor, width: '100%', height: '100%', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', mr: '10rem' }}>
//                                     <Typography display="flex" variant="h4" fontWeight="600" color={moteSecondary} 
//                                                 sx={{ wordWrap: 'break-word', wordBreak: 'break-word', textAlign: "center", justifyContent: "center", alignItems: "center", ml: "1rem", mr: "1rem", mt: "1rem", mb: "1rem", height: "100%", lineHeight: "1.75" }}
//                                         >
//                                         The People's page is a powerful tool that lets you track and manage all of your past meetings 
//                                         with anyone you've ever met with. Our platform keeps a chronological history of all of your 
//                                         past interactions and provides summaries and action items from those meetings, so you never 
//                                         forget important details. It's like having a personal assistant to help you get up to speed with 
//                                         what you have next. With the People's page, you'll always be prepared and ready for your next meeting, 
//                                         no matter how long ago it was. So why waste time rifling through your old notes and emails? Our 
//                                         People's page allows you to seamlessly stay organized and on top of your game.
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                 </Box>
//             </Box>
            
//             <Box id={fourthLevel} bgcolor={moteSecondary} width="100%" height="100vh" display="flex" justifyContent="center" alignItems="center" flexDirection="column">
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: "center", width: "100%" }}>
//                     <Grid container spacing={2}>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', flexDirection: 'column', ml: '10rem' }}>
//                                 <Typography variant="h2" fontWeight="700" mb="2rem" ml="10rem" color={moteColor} sx={{ textAlign: "center" }}>Never Worry About Keeping Tabs on Your Files Again.</Typography>
//                                 <Box sx={{ border: `4px solid ${moteColor}`, backgroundColor: moteSecondary, width: '100%', height: '100%', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', ml: '10rem' }}>
//                                     <Typography display="flex" variant="h4" fontWeight="600" color={moteColor} 
//                                                 sx={{ wordWrap: 'break-word', wordBreak: 'break-word', textAlign: "center", justifyContent: "center", alignItems: "center", ml: "1rem", mr: "1rem", mt: "1rem", mb: "1rem", height: "100%", lineHeight: "1.75" }}
//                                         >
//                                         The Upload page is a central hub for all your file management needs. With the ability to connect your Google Drive, 
//                                         OneDrive, and local storage, uploading files has never been easier. Simply upload your files to our platform and let 
//                                         us handle the rest. Our platform takes care of all the file management, so you can focus on what's important. With our 
//                                         Upload page, you can store and access all your files in one central location, making it easy to share them with others. 
//                                         Say goodbye to cluttered folders and lost files. Our platform helps you stay organized and efficient. Try our Upload page 
//                                         today and streamline your file management.
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                         </Grid>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column' }}>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginBottom={5}>
//                                     <IconButton onClick={scrollToThird}>
//                                         <ExpandLessRounded sx={{ color: moteColor, fontSize: 50 }} />
//                                     </IconButton>
//                                 </Box>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginTop={5} marginBottom={5}>
//                                     <MoteColoredIcon sx={{ fontSize: 100 }} />
//                                 </Box>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginTop={5}>
//                                     <IconButton onClick={scrollToFifth}>
//                                         <ExpandMoreRounded sx={{ color: moteColor, fontSize: 50 }} />
//                                     </IconButton>
//                                 </Box>
//                             </Box>
//                         </Grid>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', flexDirection: 'column', mr: '10rem' }}>
//                                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', flexDirection: 'column', mr: '10rem' }}>
//                                     <Typography variant="h2" fontWeight="700" mb="2rem" color={moteColor}>This is Where the Magic Begins.</Typography>
//                                     <IconButton onClick={expandImage}>
//                                         <img
//                                             src={UploadPageImg}
//                                             id={UploadPageImg}
//                                             alt="Upload Page Image"
//                                             style={{ maxWidth: "100%", height: "auto", border: `4px solid ${moteColor}`, borderRadius: "10px" }}
//                                         />
//                                     </IconButton>
//                                     <Typography variant="h2" fontWeight="700" mt="2rem" color={moteColor}>Share Your Files, We Take Care of the Rest.</Typography>
//                                     <ImageDialog />
//                                 </Box>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                 </Box>
//             </Box>

//             <Box id={fifthLevel} bgcolor={moteColor} width="100%" height="100vh" display="flex" justifyContent="center" alignItems="center" flexDirection="column">
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: "center", width: "100%" }}>
//                     <Grid container spacing={2}>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', flexDirection: 'column', ml: '10rem' }}>
//                                 <Typography variant="h2" fontWeight="700" mb="2rem" color={moteSecondary} sx={{ textAlign: "center" }}>Generate Summaries and Visualizations of Your Files.</Typography>
//                                 <IconButton onClick={expandImage}>
//                                     <img
//                                         src={SearchPageImg}
//                                         id={SearchPageImg}
//                                         alt="Search Page Image"
//                                         style={{ maxWidth: "100%", height: "auto", border: `4px solid ${moteSecondary}`, borderRadius: "10px" }}
//                                     />
//                                 </IconButton>
//                                 <Typography variant="h2" fontWeight="700" mt="2rem" color={moteSecondary} sx={{ textAlign: "center" }}>Make Your Workflows More Efficient Than Ever Before.</Typography>
//                                 <ImageDialog />
//                             </Box>
//                         </Grid>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column' }}>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginBottom={5}>
//                                     <IconButton onClick={scrollToFourth}>
//                                         <ExpandLessRounded sx={{ color: moteSecondary, fontSize: 50 }} />
//                                     </IconButton>
//                                 </Box>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginTop={5} marginBottom={5}>
//                                     <MoteIcon sx={{ fontSize: 100 }} />
//                                 </Box>
//                                 <Box display="flex" justifyContent="center" alignItems="center" marginTop={5}>
//                                     <IconButton onClick={scrollToTop}>
//                                         <VerticalAlignTopRounded sx={{ color: moteSecondary, fontSize: 50 }} />
//                                     </IconButton>
//                                 </Box>
//                             </Box>
//                         </Grid>
//                         <Grid item xs={4}>
//                             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', flexDirection: 'column', mr: '10rem' }}>
//                                 <Typography variant="h2" fontWeight="700" mb="2rem" mr="10rem" color={moteSecondary} sx={{ textAlign: "center" }}>Beautiful Summaries and Visualizations at Your Fingertips.</Typography>
//                                 <Box sx={{ border: `4px solid ${moteSecondary}`, backgroundColor: moteColor, width: '100%', height: '100%', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', mr: '10rem' }}>
//                                     <Typography display="flex" variant="h4" fontWeight="600" color={moteSecondary} 
//                                                 sx={{ wordWrap: 'break-word', wordBreak: 'break-word', textAlign: "center", justifyContent: "center", alignItems: "center", ml: "1rem", mr: "1rem", mt: "1rem", mb: "1rem", height: "100%", lineHeight: "1.75" }}
//                                         >
//                                         Our search page is the perfect tool to help you quickly find what you're looking for across your entire file library. 
//                                         With customizable filters, you can narrow down your search to specific criteria and get results in seconds. The files 
//                                         are summarized in an intuitive way that provides you with a clear overview of each document's content and relevance. 
//                                         Additionally, the search page generates beautiful visualizations of the document hierarchy to better understand where 
//                                         the files are coming from, making it easier for you to explore and navigate your files. With the ability to download 
//                                         summaries and visualizations, our search page is an invaluable tool for anyone looking to easily find and understand 
//                                         their files.
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                 </Box>
//             </Box>
//         </Box>
//     )
// };

// export default LandingPage;